<template>
	<div class="Services">
		<Service 
			v-for="service in services" 
			:key="service.id" 
			:imgID="service.imgID"
			:title="service.title"
			:text="service.text"
			:textID="service.textID"
			:image="service.image"
		/>
	</div>
</template>

<script>
import Service from '@/components/Services/Service/Service'

export default {
	name: 'Services',
	components: {
		Service
	},
	computed: {
		services() {
			return [
				{ 
					title: this.$t('ServiceTitleAutografika'), 
					id: 1, 
					imgID: 1,
					image: 'autografika',
					text: this.$t('SerivceDescriptionAutografika'),
					textID: 'autografika'
				},
				{ 
					title: this.$t('ServiceTitleForeksPleksi'), 
					id: 2, 
					imgID: 2,
					image: 'forekspleksi',
					text: this.$t('SerivceDescriptionForeksPleksi'),
					textID: 'forekspleksi'
				},
				{ 
					title: this.$t('ServiceTitlePVC'), 
					id: 3, 
					imgID: 3,
					image: 'pvc-naljepnice',
					text: this.$t('SerivceDescriptionPVC'),
					textID: 'pvc'
				},
				{ 
					title: this.$t('ServiceTitlePromo'), 
					id: 4, 
					imgID: 4,
					image: 'promo',
					text: this.$t('ServiceDescriptionPromo'),
					textID: 'promo'
				},
				{ 
					title: this.$t('ServiceTitleCerade'), 
					id: 5, 
					imgID: 4,
					image: 'cerade',
					text: this.$t('ServiceDescriptionCerade'),
					textID: 'cerade'
				},
				{ 
					title: this.$t('ServiceTitleSvijetlece'), 
					id: 6, 
					imgID: 4,
					image: 'svijetlece-reklame',
					text: this.$t('ServiceDescriptionSvijetlece'),
					textID: 'svijetlece'
				},
				{ 
					title: this.$t('ServiceTitleProzorska'), 
					id: 7, 
					imgID: 4,
					image: 'prozorska-grafika',
					text: this.$t('ServiceDescriptionProzorska'),
					textID: 'prozorska'
				},
			] 
		}
	}
}
</script>

<style lang="scss" scoped>

.Services {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}
</style>

